import { render, staticRenderFns } from "./PractitionerAnnualReturnsTaskQueue.vue?vue&type=template&id=0137f693&scoped=true&"
import script from "./PractitionerAnnualReturnsTaskQueue.vue?vue&type=script&lang=js&"
export * from "./PractitionerAnnualReturnsTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./PractitionerAnnualReturnsTaskQueue.vue?vue&type=style&index=0&id=0137f693&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0137f693",
  null
  
)

export default component.exports